import React, { FC } from 'react'
import _ from 'lodash'
import { Link } from 'gatsby'
import { graphql } from 'gatsby'

import Layout from '../components/layout'
import SEO from '../components/seo'

import '../style/normalize.css'
import '../style/all.scss'
import { SiteMetadataI } from '../types/data-models'

interface TagIndexI {
  data: {
    site: {
      siteMetadata: SiteMetadataI
    }
    allMarkdownRemark: {
      distinct: string[]
    }
  }
}
const TagIndex: FC<TagIndexI> = ({ data }) => {
  const siteTitle = data.site.siteMetadata.title
  const tags = data.allMarkdownRemark.distinct

  return (
    <Layout title={siteTitle}>
      <SEO title="Tags" />
      <header className="tag-page-head">
        <h1 className="page-head-title">Tags({tags.length})</h1>
      </header>
      <div className="tag-container">
        {tags.map((tag) => {
          return (
            <Link key={tag} style={{ textDecoration: 'none' }} to={`/tags/${_.kebabCase(tag)}`}>
              <div className="tag-item">#{tag}</div>
            </Link>
          )
        })}
      </div>
    </Layout>
  )
}

export const query = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark {
      distinct(field: frontmatter___tags)
    }
  }
`

export default TagIndex
